import React, { useRef } from "react";

import useStyles from "./styles";

import LabelForm from "Components/Form/Label";
import DocumentsComponent from "Components/DocumentsComponent";
import { WaybillDocument } from "Models/waybill.document";
import { GenerateReportDrawer, GenerateReportDrawerHandles } from "Components/GenerateReport";
import { Button } from "Components/Form";

export default function DispatchSection() {
  const classes = useStyles();

  const drawerRef = useRef<GenerateReportDrawerHandles>(null);

  const openDrawer = () => {
    drawerRef.current?.open();
  };

  const documentsList: WaybillDocument[] = [
    {
      id: 1,
      documentId: 101,
      uploaded: true,
      name: "Nota Fiscal.pdf",
      jobId: 1,
      dueDate: "2025-05-23T01:01:00.000Z",
      file: null,
      fileType: "application/pdf",
      userId: 1,
      createdAt: new Date(),
      updatedAt: new Date(),
      filename: null,
      uploadedAt: null,
      reference: "",
      generated: false,
    },
  ];

  const requiredDocuments = [
    { id: 101, name: "Nota Fiscal", reference: "NF", generated: false },
    { id: 102, name: "Guia de Transporte", reference: "GT", generated: false },
  ];

  const jobs = [
    { id: 1, reference: "12345" },
    { id: 2, reference: "67890" },
  ];

  const handleUpload = (uri: string, document: any, jobId?: number) => {};

  const handleUploadViaModal = (
    uri: string,
    name: string,
    dueDate: Date,
    callbackFunc: () => void,
    jobId?: number
  ) => {
    callbackFunc();
  };

  return (
    <>
      <div>
        <div>
          <LabelForm className={classes.formLabel}>DocumentsComponent</LabelForm>
        </div>
        <DocumentsComponent
          isUploading={false}
          documentsList={documentsList}
          requiredDocuments={requiredDocuments}
          isDisabled={false}
          withAccordion={true}
          dataToRenderAccordions={jobs}
          onUpload={handleUpload}
          onUploadViaModal={handleUploadViaModal}
          actionButtonProps={{
            onSave: () => alert("Salvando..."),
            onCancel: () => alert("Cancelado"),
          }}
        />
        <hr />
      </div>
      <div>
        <div>
          <LabelForm className={classes.formLabel}>GenerateReportDrawer</LabelForm>
        </div>
        <GenerateReportDrawer ref={drawerRef} />
        <Button variant="contained" color="primary" onClick={openDrawer}>
          Open
        </Button>
      </div>
    </>
  );
}
